import React, { useState, useEffect } from 'react';
import { Row, Col, Button, Flex, Space, Input } from 'antd';
import { PageSection, PageTitle, PageContent, Field, PageFilters, PageHeader, StickyButtons } from '../../styles/global/Pages.styled';
import { Widget } from "../Global/Atomics/Widget";
import { Text } from '../Global/Atomics/Text';
import CustomIcon from '../Global/Icons/CustomIcon';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router';
import useFetch from '../../server/useFetch';
import query from '../../server/constants.api';
import { BasicTable } from '@synergy/table';
import styled from 'styled-components';
import Spinner from '../Global/Atomics/Spinner';
import i18next from 'i18next';

export const RegisterDetailView = ({ selectedPOI, onClose }) => {
  const { t } = useTranslation();
  const [rgData, setRgData] = useState(null);
  const [rlData, setRlData] = useState(null);
  const [showMore, setShowMore] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const itemId = selectedPOI?.id;

  const { data: registryDetailData, isLoading: registryDetailLoading, refetch: refetchRegistryDetail } = useFetch(query.path.registryDetail, 'getRegistryDetail', { id: itemId, language: i18next.resolvedLanguage });
  const { data: relatedLinksData, isLoading: relatedLinksLoading, refetch: refetchRelatedLinks } = useFetch(query.path.relatedLinks, 'getRelatedLinks', { id: itemId });

  useEffect(() => {
    try {
      if (registryDetailData?.data) {
        setRgData(registryDetailData?.data);
      }
    } catch (error) {
      console.error('(RegisterDetailView page) Error in useEffect setting registryDetailData:', error);
      //reportError(error); // Send error report to backend
    }
  }, [registryDetailData]);

  useEffect(() => {
    try {
      if (relatedLinksData?.data) {
        setRlData(relatedLinksData?.data);
      }
    } catch (error) {
      console.error('(RegisterDetailView page) Error in useEffect setting relatedLinksData:', error);
      //reportError(error); // Send error report to backend
    }
  }, [relatedLinksData]);

  const hideData = () => {
    try {
      setShowMore(false);
    } catch (error) {
      console.error('(RegisterDetailView page) Error in hideData function:', error);
      //reportError(error); // Send error report to backend
    }
  }

  const openActiveDetail = () => {
    const url = '/home/register/registerDetail/' + rgData?.id;
    window.open(url, '_blank');
  }

  const showData = () => {
    try {
      setShowMore(true);
    } catch (error) {
      console.error('(RegisterDetailView page) Error in showData function:', error);
      //reportError(error); // Send error report to backend
    }
  }

  return (

    <>
    {registryDetailData ? 
      <PageContent id={rgData?.id} $backgroundColor='neutral-1'>
        <PageHeader $backgroundColor='neutral-1'>
          <Flex align="center" justify="space-between">
            <PageTitle>
              <div className="title">
                <Text $fontColor='coolgray-12' $fontSize='text_md' $weight='medium' $marginTop='s05' $marginBottom='s05'>{rgData?.title}</Text>
              </div>
            </PageTitle>
            <Flex align="center" flex="none">
              {/* <a type="link" href={'/home/register/registerDetail/' + rgData?.id} shape="rounded">
                <Text $fontColor='blue-4' $fontSize='text_sm' $weight='regular' $marginTop='s03' $marginBottom='s03' $marginRight='s05'>Ver detalhe</Text>
              </a> */}
              <Button className='ant-btn ant-btn-blue -small' shape="circle" size='small' onClick={onClose} icon={<CustomIcon icon={'Close'} iconsize='xs' color='white' />} />
            </Flex>
          </Flex>
        </PageHeader>

        <PageSection id="registerData" className='first-section'>
          <Row gutter={[32, 32]}>
            <Col span={24}>
              <Row gutter={[16, 16]}>
                {rgData?.data?.map((item, index) => (
                  index < 10 ?
                    <Col span={12} key={index} className='d-flex'>
                      <Field id={item?.id} $backgroundColor="neutral-3" className='full-width' >
                        <Text $fontColor='coolgray-10' $fontSize='text_xs' $weight='regular'>{item?.label}</Text>
                        <Text $fontColor='coolgray-12' $fontSize='text_sm' $weight='regular'>{item?.value && item?.value != '' ? item?.value : '-'}</Text>
                      </Field>
                    </Col>
                    : (showMore ?
                      <Col span={12} key={index} className='d-flex'>
                        <Field id={item?.id} $backgroundColor="neutral-3" className='full-width' >
                          <Text $fontColor='coolgray-10' $fontSize='text_xs' $weight='regular'>{item?.label}</Text>
                          <Text $fontColor='coolgray-12' $fontSize='text_sm' $weight='regular'>{item?.value ?? '-'}</Text>
                        </Field>
                      </Col>
                      : null)
                ))}
                {rgData?.data?.length > 10 ?
                  < Col span={24} >
                    {showMore ?
                      <Flex align="center" justify="center">
                        <Button type="link" onClick={hideData}>
                          <Flex align="center" justify="center">
                            <Text $fontColor='blue-4' $fontSize='text_sm' $weight='medium' $marginRight="s03">{t('seeLess')}</Text>
                            <CustomIcon icon={'ChevronUp'} iconsize='xs' color='blue-4' />
                          </Flex>
                        </Button>
                      </Flex>
                      :
                      <Flex align="center" justify="center">
                        <Button type="link" onClick={showData}>
                          <Flex align="center" justify="center">
                            <Text $fontColor='blue-4' $fontSize='text_sm' $weight='medium' $marginRight="s03">{t('seeMore')}</Text>
                            <CustomIcon icon={'ChevronDown'} iconsize='xs' color='blue-4' />
                          </Flex>
                        </Button>
                      </Flex>
                    }
                  </Col> : null
                }
              </Row>
            </Col>
            <Col>
              <Button className='ant-btn-blue -small' onClick={openActiveDetail}>{t('seeDetail')}</Button>
            </Col>
          </Row>
        </PageSection >
        {showEdit ? null :
          <PageSection>
            <Row gutter={[32, 32]}>
              <Col span={24}>
                <PageTitle>
                  <div className="title">
                    <Text $fontColor='coolgray-12' $fontSize='text_md' $weight='medium' $marginRight='s03'>{t('relatedAssets')}</Text>
                  </div>
                </PageTitle>
              </Col>
              <Col span={24}>
                <BasicTable tableId='tableIdTthree' fetchData={rlData} hrefLink={null} />
              </Col>
            </Row>
          </PageSection>

        }
      </PageContent >
      : <div style={{ height: 'inherit', width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}><Spinner stroke="green" /></div>
      }
    </>
  );
}